import { useEffect, useRef, useState } from 'react'
import dayjs from 'dayjs'

export interface CountdownTime {
  days: number | string
  hours: number | string
  minutes: number | string
  seconds: number | string
  milliseconds: number | string
}

export function useCountdown(oneCycle: number) {
  const [time, setTime] = useState<CountdownTime>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0
  })

  const range = useRef<[string, string]>(['', '']) // 起止日期范围
  const baseDate = useRef(new Date(2025, 1, 18)) // 注意：1 表示 2 月

  useEffect(() => {
    baseDate.current.setHours(0, 0, 0, 0)

    const getNextTargetDate = () => {
      const now = new Date()
      const targetDate = new Date(baseDate.current)

      while (targetDate <= now) {
        targetDate.setDate(targetDate.getDate() + oneCycle)
      }

      const startDate = new Date(targetDate)
      startDate.setDate(startDate.getDate() - oneCycle)
      const endDate = new Date(targetDate)
      endDate.setDate(endDate.getDate() - 1)

      const startStr = dayjs(startDate).format('YYYY-MM-DD')
      const endStr = dayjs(endDate).format('YYYY-MM-DD')

      if (range.current[0] !== startStr) {
        range.current = [startStr, endStr]
      }

      return targetDate
    }

    const updateCountdown = () => {
      const now = new Date().getTime()
      const target = getNextTargetDate().getTime()
      const diff = target - now

      setTime({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: String(Math.floor((diff / (1000 * 60 * 60)) % 24)).padStart(2, '0'),
        minutes: String(Math.floor((diff / (1000 * 60)) % 60)).padStart(2, '0'),
        seconds: String(Math.floor((diff / 1000) % 60)).padStart(2, '0'),
        milliseconds: Math.floor((diff % 1000) / 100)
      })
    }

    const timer = setInterval(updateCountdown, 100)
    updateCountdown()

    return () => clearInterval(timer)
  }, [oneCycle])

  return {
    time,
    dateRange: range.current // [起始日期, 结束日期]
  }
}
